export const DEFAULT_SELECTED_DICTIONARY_COUNTRY_ID = 267; // UK

export const FILTERING_THROTTLE_INTERVAL = 500;

export const DATE_TIME_FORMAT = 'DD-MMM-YYYY, HH:mm';

export const DATE_FORMAT = 'DD-MMM-YYYY';

export const TIME_FORMAT = 'HH:mm';

export const TABLE_SIZE_CONFIG = [10, 20, 30] as const;